import React, { useEffect, useRef, useState } from 'react';
import Modal from '../../../../../../components/Modal';
import Button from '../../../../../../components/Button';
import Table from '../../../../../../components/_table/Table/Table';
import useProductListModal from '../hooks/useProductListModal';
import { columns } from '../columns';
import { TableOption } from '../types';
import { ProductItem } from '../../../types';
import { INITIAL_OPTION_MODEL } from '../constants';
import { ProductAndTagListModalStyle } from '../../common/style';

type NormalizedProductList = {
  [key: string]: ProductItem;
};

interface ProductListModalProps {
  closeModal: () => void;
  selectedProductIdList: number[];
  onSubmit: (value: ProductItem[]) => void;
}
const ProductListModal = (props: ProductListModalProps) => {
  const { closeModal, selectedProductIdList, onSubmit } = props;
  const [checkedIdList, setCheckedIdList] = useState<number[]>([]);
  const [tableOption, setTableOption] = useState<TableOption>(INITIAL_OPTION_MODEL);
  const { filterOption, pagination } = tableOption;
  const { data } = useProductListModal(tableOption, selectedProductIdList);
  const cachedProductList = useRef<NormalizedProductList>({});

  // 이미 선택된 상품, 상품 리스트 모달 체크리스트에 중복 제거하여 추가
  useEffect(() => {
    setCheckedIdList((prev) => [...new Set([...prev, ...selectedProductIdList])]);
  }, [selectedProductIdList]);

  // 한번이라도 체크된 모든 상품 정보를 캐싱하는 함수
  const setCachedProductList = (checkedList: number[]) => {
    if (!data?.productList) return;

    const checkedIdListSet = new Set(checkedList);

    cachedProductList.current = {
      ...cachedProductList.current,
      ...Object.fromEntries(
        data.productList.filter(({ id }) => checkedIdListSet.has(id)).map((item) => [item.id, item]),
      ),
    };
  };

  const resetOption = () => {
    setTableOption(INITIAL_OPTION_MODEL);
  };

  const handleCheck = (checkedList: number[]) => {
    setCheckedIdList(checkedList);
    setCachedProductList(checkedList);
  };
  const handleSubmit = () => {
    if (!data?.productList) return;
    const selectedProductIdListSet = new Set(selectedProductIdList);

    onSubmit(
      checkedIdList.filter((id) => !selectedProductIdListSet.has(id)).map((id) => cachedProductList.current[id]),
    );
  };

  return (
    <Modal
      title="상품 리스트"
      isOpen={true}
      width={1200}
      height={687}
      isFooter={true}
      onOk={handleSubmit}
      onClose={() => closeModal()}
    >
      <ProductAndTagListModalStyle>
        <div className="summary">
          <span className="total-cnt">
            <span className="cnt">{data!.totalCount}</span>건이 조회되었습니다.
          </span>

          <div className="button-group">
            <Button isRadius color="primary" text="필터 초기화" onClick={resetOption} />
          </div>
        </div>
        <Table
          rowKey={(record: ProductItem) => record.id}
          columns={(utils: any) => columns({ ...utils, isModal: true })}
          list={data!.productList}
          size="middle"
          bordered={true}
          onCheck={handleCheck}
          selectedList={checkedIdList}
          getList={(data: TableOption) => {
            setTableOption({
              ...tableOption,
              ...data,
            });
          }}
          pagination={{
            ...pagination,
            totalCnt: data!.totalCount,
          }}
          filterOption={filterOption}
        />
      </ProductAndTagListModalStyle>
    </Modal>
  );
};

export default ProductListModal;
